import React from 'react';
import { DetailsList as DetailsListBase, IDetailsListProps } from '@fluentui/react';
import { getDetailsListStyles } from './Style';
export const DetailsList: React.FC<IDetailsListProps> = (props) => {
    return (
        <DetailsListBase
            className={`${getDetailsListStyles()}${props.className ? ' ' + props.className : ''} `}
            {...props} />
    );
};